import React, { useState } from 'react';
import ListItem from "@mui/material/List";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Accueil',
        link: '/home'
    },
    {
        id: 2,
        title: 'Mes consultations',
        link: '/service'
    },
    {
        id: 3,
        title: 'A propos de moi',
        link: '/about'
    },
    {
        id: 4,
        title: 'Prendre rendez-vous',
        link: '/contact'
    }
]


const MobileMenu = () => {

    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false); // Ferme le menu après clic
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem key={mn}>
                                <NavLink onClick={ClickHandler} className="active" to={item.link}>
                                    {item.title}
                                </NavLink>
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;